import React, { useRef, useState } from 'react';

import styled from 'styled-components'
import { RemoveButtonTrashCan, AddButton } from '../../reusableItems/buttons';
import {VscChromeClose, VscCheck} from 'react-icons/vsc';
import { BsCalendar3 } from 'react-icons/bs';
import { MdEdit } from "react-icons/md";
import { CalendarPicker, useCloseOnOutsidePress } from '../../reusableItems/calendar';
import { DragableList, DragHandle } from '../../item_page/dragableList';
import styles from './listOfActions.module.scss';
import { dateFormatter, timeFormatter } from '../../../../supplementary_components/supplementaryMethods';
// import { InputFieldDelegate } from '../../../forms/input_fields/inputFieldDelegate';

const TaskListSection = styled.div`
    .actionBox{
        display:grid;
        grid-template-columns: 1fr 0.3rem;
        column-gap:0.3rem;
        padding:1rem;
        margin:0.5rem 0 0.5rem 0;
        background-color:var(--medium-lighter-gray);
        color:var(--dark-gray);
        border-radius:0.4rem;
        // 
        .actionTitle{
            position:relative;
            font-weight:700;
            
            svg{
                color:var(--lighter-gray);
                position:absolute;
                // float:right;
                top:-0.7rem;
                right:-1.0rem;
                cursor:pointer;
                transition: 0.3s;
                :hover{
                    color:var(--dark-gray);
                }
            }
        }
        .actionDesc{
            margin-top:0.5rem;
            font-size:0.9rem;
        }
        textarea, input{
            padding:0.5rem;
            height:2.1rem;
            margin-bottom:0.5rem;
            background-color:rgba(1, 1, 1, 0.0);
            font-size:0.9rem !important;
            font-weight:500  !important;
            resize: vertical;
        }
        .selectWithRemoveButton{
            display:flex;
            div{
                height:1.8rem;
                margin-left:0.5rem;
            }
        }
        select{
            margin-bottom:0.5rem;
            background-color:rgba(1, 1, 1, 0.0);
            // background-color:red;
            font-size:0.9rem !important;
            font-weight:500  !important;
            padding:0.3rem;
            // width:60%;
        }
        option{
            background-color: var(--bg);
        }
        .buttons{
            display:grid;
            grid-template-columns: 1fr 1fr;
            justify-content:center;
            align-items:center;
            margin-bottom:-0.3rem;
            svg{
                margin: 0 auto;
                cursor:pointer;
                stroke-width:2px;
            }
            svg:first-child{
                color:var(--main-color);
            }
            svg:last-child{
                color:var(--alert-color);
            }
        }
       
    }
`;
export const TypeToTitle  = (type) => {
    switch (type) {
        case "shop":
            return "Shop";
        case "puTrailer":
            return "Pickup Trailer";
        case "dropTrailer":
            return "Drop Trailer";
        case "swapTrailer":
            return "Swap Trailers";
        case "yard":
            return "Yard";
        case "park":
            return "Park";
        case "homeTime":
            return "Home Time";
        case "reset":
            return "Reset";
        case "custom":
            return "Custom Task";
        default:
            break;
    }
}

export const ActionList = ({currentTask, taskIndex, tasks, setTasks, changedTasks}) => {
    if(typeof(currentTask.actions) === 'string')currentTask.actions = JSON.parse(currentTask.actions);
    
    const editableActionForm = useRef(null);
    const selectedTypeField = useRef(null);
    const taskDurationField = useRef(null);
    const selectedDescField = useRef(null);
    const [beingEdited, setBeingEdited] = useState(currentTask.actions.length===0?null:null);
    const indexIdentifier = (button) => {
        let actionBox = button;
        while(!actionBox.className.includes('actionBox')){
            actionBox = actionBox.parentNode
        }
        for (let i = 0; i < actionBox.parentNode.childElementCount; i++){
            if(actionBox.parentNode.childNodes[i] === actionBox){
                return i;
            }

        }
    }
    const removeAction = (e) => {
        const indexOfActionBeingRemoved = indexIdentifier(e.target.parentNode.parentNode);
        const taskData = JSON.parse(editableActionForm.current.getAttribute('data-value'));
        const tasksCopy = [...tasks];
        for(let i = 0; i < tasksCopy.length; i++){
            if(tasksCopy[i].id === taskData.id){
                tasksCopy[i].actions.splice(indexOfActionBeingRemoved, 1);
                close();
                changedTasks.push(tasksCopy[i]);
                setTasks(tasksCopy);
                return;
            }
        }
    }
    const editAction = (e) => {
        const indexOfActionBeingEdited = indexIdentifier(e.target.parentNode.parentNode);
        setBeingEdited({indx: indexOfActionBeingEdited, type: currentTask.actions[indexOfActionBeingEdited].type, desc: currentTask.actions[indexOfActionBeingEdited].desc, durationInDays: currentTask.actions[indexOfActionBeingEdited].durationInDays || null });
        
    }
    const submitChanges = () => {
        const taskData = JSON.parse(editableActionForm.current.getAttribute('data-value')); 
        const actionType = selectedTypeField.current.value;   
        const actionDesc = selectedDescField.current.value;    
        if(invalidActionBasedOnTypeAndDesc(actionType, actionDesc)){
            if(!selectedDescField.current.className.includes('subError')){
                selectedDescField.current.classList += ' subError';
            } 
            return;
        }
        
        const tasksCopy = [...tasks];
        const newOrEditedTask = ({data}) => {
            const res = {
            "loadAction" : false,
            "dispatched": data?data.dispatched:false,
            "dispatchingRequired": data?data.dispatchingRequired:true,
            "title": TypeToTitle(actionType),
            "type": actionType,
            "desc": actionDesc,
            "completed": false,
            }
            // try {
            //     if(actionType === "homeTime" && taskDurationField.current.value !== ""){
            //         delete res.resetEndETA;
            //         res["durationInDays"] = parseInt(taskDurationField.current.value)
            //     }else if(actionType === "reset" && taskDurationField.current.value !== ""){
            //         res["durationInDays"] = parseInt(taskDurationField.current.value);
            //         // let resetEndETA = null;
            //         try {
            //             if(currentTask.apptDate && currentTask.apptTime){
            //                 res["resetEndETA"]= dateTimeToResetEndString(currentTask.apptDate, currentTask.apptTime, res["durationInDays"]); 
            //             }
            //         } catch (error) {
            //         }
            //     }else{
            //         delete res.resetEndETA;
            //         delete res.durationInDays;
            //     }
            // } catch (error) {
            // }
            
            return res;
        }
        for(let i = 0; i < tasksCopy.length; i++){
            if(tasksCopy[i].id === taskData.id){
                if(taskData.editingExistingAction){
                    for(let k = 0; k < tasksCopy[i].actions.length; k++){
                        if(k === taskData.actionIndex){
                            tasksCopy[i].actions[k] = newOrEditedTask(tasksCopy[i].actions[k]);
                            break;
                        }
                    }
                }else{
                    tasksCopy[i].actions.push(newOrEditedTask(false))
                }
                close();
                if(tasksCopy[i].zonedDateTime === '')tasksCopy[i].zonedDateTime = null;
                changedTasks.push(tasksCopy[i]);                
                setTasks(tasksCopy);
                return;
            }
        }
    }
    const close = () => {
        setBeingEdited(null);
        editableActionForm.current.className = editableActionForm.current.className.replace('subError', '');
        selectedDescField.current.className = selectedDescField.current.className.replace('subError', '');
        selectedDescField.current.value = "";
    }
    const addAction = () => {
        setBeingEdited({indx: currentTask.actions.length});
    }
    
    const ListOfActions = () => <>        
        {currentTask.actions.map((action, index)=>{
            
            if(action.completed)return null;
            const desc = action.loadAction ? `${currentTask.apptDate.substr(0, 5)} ${currentTask.apptTime?currentTask.apptTime:''} (${action.desc.toUpperCase()})` : action.desc;
            if(beingEdited && beingEdited.indx === index)return NewActionForm(index, currentTask.actions.length, beingEdited, currentTask, editableActionForm, selectedTypeField, selectedDescField, submitChanges, close, removeAction, taskDurationField);
            return <div key={index} className="actionBox">
                <div>
                    <div className="actionTitle">{action.title} {!action.loadAction && action.type !== "homeTime" && action.type !== "reset" ? <MdEdit onClick={editAction} /> : null }</div>
                    {action.durationInDays ? <div className="actionDesc">{`Duration: ${action.durationInDays} ${action.type === 'reset' ? ' hour(s)' : ' day(s)' }`}</div> : null}
                    {!action.resetEndETA && action.endingTimeType === "Until" ? <div className="actionDesc">{`Until: ${action.endDate} ${action.endTime||""}`}</div> : null}
                    {action.resetEndETA ? <div className="actionDesc">Finishes: {action.resetEndETA}</div>:null}
                    {desc ? <div className="actionDesc">{desc}</div> : null}
                </div>
                {currentTask.actions.length > 1 ? 
                    <DragHandle handleClassName='actionDragHandle' />
                    : null
                }
                
            </div>
            
        })}
        
    </>
    return <TaskListSection id="actionsContainer" >
        <DragableList component={ListOfActions} handleClassName='actionDragHandle' finishDrag={(inititIndex, currentIndex)=>{
            if (inititIndex !== currentIndex){
                const tasksCopy = [...tasks];
                const replacedAction = tasksCopy[taskIndex].actions.splice(inititIndex, 1)[0];
                tasksCopy[taskIndex].actions.splice(currentIndex, 0, replacedAction);
                changedTasks.push(tasksCopy[taskIndex]);
                setTasks(tasksCopy);
            }
            return true
        }} />
        {currentTask.actions.length===0 || (beingEdited && beingEdited.indx === currentTask.actions.length) ?
            NewActionForm(null, currentTask.actions.length, beingEdited, currentTask, editableActionForm, selectedTypeField, selectedDescField, submitChanges, close, removeAction, taskDurationField)
        :
        null
        }
        <AddButton customSize={'1.2rem'} action={addAction} inactive={beingEdited !== null || (currentTask.actions.length > 0 && (currentTask.actions[0].type === "homeTime" || currentTask.actions[0].type === "reset"))} />
    </TaskListSection>
     
}
export function invalidActionBasedOnTypeAndDesc(type, desc){
    return (type !== "homeTime" 
        && type !== "reset" 
        && type !== "park" 
        && type !== "dropTrailer" 
        && type !== "yard"
        && desc === "" )
    
}
function NewActionForm(index, actionCount, beingEdited, currentTask, editableActionForm, selectedTypeField, selectedDescField, submitChanges, close, removeAction, taskDurationField) {    
    const FormData = beingEdited && beingEdited.type ?{id:currentTask.id, editingExistingAction:true, actionIndex:beingEdited.indx}:{id:currentTask.id};
    return <div key={index} className="actionBox" style={{position:"relative", display: beingEdited !== null || actionCount===0 ? 'block' : 'none'}} data-value={JSON.stringify(FormData)} ref={editableActionForm}>
        <div className="selectWithRemoveButton">
            <select id="actionsType" ref={selectedTypeField} defaultValue={beingEdited !== null ? beingEdited.type : null} onChange={(e)=>{
                
            }}>  
                {!currentTask.loadId ? <option value="shop">Shop</option> : null}
                <option value="puTrailer">Pickup Trailer</option>
                <option value="dropTrailer">Drop Trailer</option>
                <option value="swapTrailer">Swap Trailers</option>
                {!currentTask.loadId ? <option value="yard">Yard</option> : null}
                {!currentTask.loadId ? <option value="park">Park</option> : null}
                {/* {!currentTask.loadId && (actionCount === 0 || index === 0) ? <option value="homeTime">Home Time</option> : null} */}
                {/* {!currentTask.loadId && (actionCount === 0 || index === 0) ? <option value="reset">Reset</option> : null} */}
                {!currentTask.loadId ? <option value="custom">Custom Task</option> : null}
            </ select>
            {beingEdited && beingEdited.type && actionCount > 1 ? <RemoveButtonTrashCan action={removeAction} /> : null}
        </div>
        {/* <input ref={taskDurationField} style={{display:beingEdited && (beingEdited.type === "homeTime" || beingEdited.type === "reset") ? "block" : "none"}} defaultValue={beingEdited && beingEdited.durationInDays ? beingEdited.durationInDays : ""} id="durationInDays" placeholder="Duration" type="number" min={1} step={1} onChange={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
        }} /> */}
        
        
        <textarea id="actionsDescription" type='text' autoComplete="new-password"  placeholder="Action Description" ref={selectedDescField} defaultValue={beingEdited !== null ? beingEdited.desc : null} onBlur={(e)=>{
            if(e.target.value !== '')e.target.className = e.target.className.replace('subError', '');
        }}></textarea>
        <div className='buttons'>
            <VscCheck onClick={submitChanges} /> <VscChromeClose onClick={currentTask.actions.length===0?()=>{}:close} style={currentTask.actions.length===0?{opacity:'0.5', cursor:'default'}:{}} />
        </div> 
    </div>;
}
//{/* <ActionWithDuration beingEdited={null} selectedTypeField={selectedTypeField} /> */}
// {index, actionCount, beingEdited, currentTask, editableActionForm, selectedTypeField, selectedDescField, submitChanges, close, removeAction, taskDurationField}
export const ActionWithDuration = ({currentTask, setTasks}) => {
    const action = currentTask.actions[0];
    const showAddressButtonRef = useRef(null);
    const _setCurrentAction = (name, newValue) => {
        action[name] = newValue;
        setTasks([{...currentTask, actions:[action]}]);
    }
    
    return <div id='resetOrHomeTimeContainer' className={styles.actionWithDurationContainer}>
        <select id="actionsType" defaultValue={action.type} onChange={(e)=>{
            if(e.target.value === "homeTime"){
                if(showAddressButtonRef?.current){
                    showAddressSection(showAddressButtonRef.current);
                }
            }
            _setCurrentAction("type", e.target.value);
            
        }} style={{background: 'var(--bg)'}} >  
            <option value="reset">Reset</option> 
            <option value="homeTime">Home Time</option> 
        </ select>
        <div className={styles.timeSetter}>
            <div>
                <div>From</div>
                <DateField fistDate={true} action={action} name="apptDate" setV={_setCurrentAction} />
                <TimeField name="apptTime" action={action} setV={_setCurrentAction} />
            </div>

            <div>
                <div className={styles.endTimeSelector}>
                    <div>
                        <div className={action.endingTimeType === "Until" ? styles.selected : ""} onClick={()=>{_setCurrentAction("endingTimeType", "Until")}}>Until</div>
                        <div className={action.endingTimeType === "Plus" ? styles.selected : ""} onClick={()=>{_setCurrentAction("endingTimeType", "Plus")}}>Plus</div>
                    </div>
                </div>
                {action.endingTimeType === "Until" ?
                <>
                    <DateField action={action} name="endDate" setV={_setCurrentAction} />
                    <TimeField name="endTime" action={action} setV={_setCurrentAction} />
                </>
                :
                <input name="durationInDays" defaultValue={action.durationInDays || ""} placeholder={`Plus ${action.type === "homeTime" ? "days" : "hours"}`} type="number" min={1} step={1} onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                }} onBlur={(e)=>{
                    removeErrorClass(e.target);
                    _setCurrentAction("durationInDays", e.target.value);
                }} />
                }
                
            </div>
        </div>
        <input type='text' name='desc' placeholder='Note' defaultValue={action.desc} onBlur={(e)=>{
            _setCurrentAction("desc", e.target.value)
        }} />
        {
            currentTask.address ?
            null :
            <div  className={styles.addAddressButton}>
                <span ref={showAddressButtonRef} onClick={(e)=>{
                    try {
                        showAddressSection(e.target);
                    } catch (error) {
                    }
                }}>
                    Add Address
                </span>
            </div>
        }
        
    </div>
}
function showAddressSection(addAddressButton){
    let target = addAddressButton.parentElement;
    target.style.display = "none";
    let count = 0;
    while(target.id !== "taskWithDurationParent" && count < 10){
        target = target.parentElement;
        count++;
    }
    const newTaskAddingForm = target.querySelector("#newTaskAddingForm");
    newTaskAddingForm.style.marginRight = "0rem";
    newTaskAddingForm.style.display = "";
}

const TaskDateFieldRow = styled.span`
	display: block;
	width: 100%;
	position: relative;
    margin-bottom: .7rem;
	& > input {
		padding-right: 2.35rem;
	}
`;

const TaskDateCalendarBtn = styled.button`
	position: absolute;
	right: 0.45rem;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.75rem;
	height: 1.75rem;
	padding: 0;
	margin: 0;
	border: none;
	border-radius: 0.3rem;
	background: transparent;
	color: var(--main-color);
	cursor: pointer;

	&:hover {
		background: var(--extra-light-gray);
	}
`;

function stripCalendarDay(d) {
	return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function formatCalendarPickDateOnly(d) {
	if (!d) return '';
	const t = stripCalendarDay(d);
	const y = t.getFullYear();
	const mo = t.getMonth() + 1;
	const day = t.getDate();
	const intermediate = `${y}-${String(mo).padStart(2, '0')}-${String(day).padStart(2, '0')} 12:00 AM`;
	const { date } = dateFormatter(intermediate);
	if (date) return date;
	return `${String(mo).padStart(2, '0')}/${String(day).padStart(2, '0')}/${String(y).slice(-2)}`;
}

function parseTaskListDateForCalendar(raw) {
	if (!raw || !String(raw).trim()) return null;
	const { date, time } = dateFormatter(String(raw).trim());
	if (!date) return null;
	const dm = date.match(/^(\d{2})\/(\d{2})\/(\d{2})$/);
	if (!dm) return null;
	const [, mo, d, yy] = dm;
	const year = 2000 + parseInt(yy, 10);
	let parsed;
	if (!time) {
		parsed = new Date(year, parseInt(mo, 10) - 1, parseInt(d, 10), 0, 0);
	} else {
		const tm = time.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
		if (!tm) return null;
		let h = parseInt(tm[1], 10);
		const mi = parseInt(tm[2], 10);
		const ap = tm[3].toUpperCase();
		if (ap === 'PM' && h !== 12) h += 12;
		if (ap === 'AM' && h === 12) h = 0;
		parsed = new Date(year, parseInt(mo, 10) - 1, parseInt(d, 10), h, mi);
	}
	return stripCalendarDay(parsed);
}

//defaultVal={apptDate} name="apptDate" setV={_setCurrentAction}
const DateField = ({fistDate, action, name, setV}) => {
	const [calendarOpen, setCalendarOpen] = useState(false);
	const shellRef = useRef(null);
	const inputRef = useRef(null);
	useCloseOnOutsidePress(calendarOpen, shellRef, () => setCalendarOpen(false));

	const raw = action[name] || '';
	const initialStart = parseTaskListDateForCalendar(raw);

	const calendarPopoverAlign = name === 'apptDate' ? 'start' : 'end';

	const applyFromCalendar = (d) => {
		const val = formatCalendarPickDateOnly(d);
		setV(name, val);
		if (inputRef.current) {
			inputRef.current.value = val;
		}
		setCalendarOpen(false);
	};

	return (
		<TaskDateFieldRow ref={shellRef}>
			<input
				ref={inputRef}
				placeholder="Date"
				name={name}
				defaultValue={action[name]}
				onBlur={(e) => {
					removeErrorClass(e.target);
					let val = e.target.value;
					if (action[name] !== val) {
						try {
							val = dateFormatter(val).date;
						} catch (error) {
							val = null;
						}
						setV(name, val);
						e.target.value = val || '';
					}
				}}
				onFocus={(e) => {
					if (e.target.value === '') {
						const todaysDate = new Date();
						todaysDate.setDate(todaysDate.getDate() + (fistDate ? 0 : 1));
						const currentMoth = `${todaysDate.getMonth() + 1}`;
						const possibleDate = `${todaysDate.getDate()}`;
						e.target.value = `${currentMoth.length === 1 ? '0' : ''}${currentMoth}/${possibleDate.length === 1 ? '0' : ''}${possibleDate}`;
					}
				}}
			/>
			<TaskDateCalendarBtn
				type="button"
				aria-label="Open calendar"
				tabIndex={-1}
				onMouseDown={(e) => e.preventDefault()}
				onClick={(e) => {
					e.stopPropagation();
					setCalendarOpen((o) => !o);
				}}
			>
				<BsCalendar3 />
			</TaskDateCalendarBtn>
			{calendarOpen ? (
				<CalendarPicker
					key={`${raw}-${calendarOpen}`}
					selectType="singleDate"
					popoverAlign={calendarPopoverAlign}
					initialStart={initialStart || undefined}
					onCancel={() => setCalendarOpen(false)}
					onApply={applyFromCalendar}
				/>
			) : null}
		</TaskDateFieldRow>
	);
};
const TimeField = ({action, name, setV}) => {
    return <input placeholder='Time' name={name}
        defaultValue={action[name]}
        onBlur={(e)=>{
            removeErrorClass(e.target);
            let val = e.target.value;
            if(action[name] !== val){
                try {
                    val = timeFormatter(val).time;
                } catch (error) {
                    val = null;
                }
                setV(name, val);
                e.target.value = val || "";
            }
        }} 
    />
}
function removeErrorClass(tag){
    if(tag && tag.className.includes('subError')){
        tag.className = tag.className.replace("subError", "");
    }
}